import React, { useState } from "react";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  ListItemIcon,
  Tooltip,
  Typography,
} from "@mui/material";
import { Configuration } from "./modules/GeneralSettings";
import { IRaffle } from "../../store/interfaces/IRaffle";
import { AddAlert, CreditCard, Numbers, Settings, WorkspacePremium, Star, Sell } from "@mui/icons-material";
import { BankAccounts } from "./modules/BankAccounts";
import { BlockedNumbers } from "./modules/RewardedNumbers";
import { PromoEngine } from "./modules/PromoEngine";
import { BadgeCheck, Bot, Megaphone, Paintbrush, UserCheck } from "lucide-react";
import { Remaining } from "./modules/Remaining";
import { Sellers } from "./modules/Sellers";
import { Customizations } from "./modules/Customization";
import { ChatBox } from "./modules/ChatBox";
import { BestPurchasers } from "./modules/BestPurchasers";

const menuItems = [
  { label: "Diseño personalizado", key: "customization", premiumConfig: true, inDev: true, icon: <Paintbrush /> },
  { label: "Chatbot con IA", key: "chatbox", premiumConfig: true, inDev: true, icon: <Bot /> },
  { label: "Configuración general", key: "general", premiumConfig: false, inDev: false, icon: <Settings /> },
  { label: "Cuentas bancarias", key: "bank", premiumConfig: false, inDev: false, icon: <CreditCard /> },
  { label: "Números", key: "blocked", premiumConfig: false, inDev: false, icon: <Numbers /> },
  { label: "Mejores compradores", key: "bestPurchasers", premiumConfig: true, inDev: false, icon: <Star /> },
  { label: "Rezagados", key: "remaining", premiumConfig: true, inDev: false, icon: <UserCheck /> },
  { label: "Promociones", key: "promo", premiumConfig: true, inDev: false, icon: <Megaphone /> },
  { label: "Vendedores", key: "sellers", premiumConfig: true, inDev: false, icon: <Sell /> },
];

interface ConfigurationProps {
  raffle: IRaffle;
}

export const SettingsMenu = ({ raffle }: ConfigurationProps) => {
  const [selectedMenu, setSelectedMenu] = useState("general");

  return (
    <Box sx={{ display: "flex" }}>
      <Divider />
      <List>
        {menuItems.filter(mi => (mi.key !== "blocked" || (raffle.accountId === 'oscar-alarcon' || raffle.accountId === 'carlos-pinango' || raffle.accountId === 'agudojhonny' || raffle.accountId === 'a-donde-la-negra' || raffle.accountId === 'minas-de-baruta'||  raffle.accountId === 'w-robles' || raffle.accountId === 'rifas-chente' || raffle.accountId === 'gerej-16' || raffle.accountId === 'rifas-jf' || raffle.accountId === 'alejandro-el-gochito'))).map((item) => (
          <Tooltip key={item.key} title={item.premiumConfig ? "Funcionalidad Premium" : ""} placement="right">
            <ListItem disablePadding>
              <ListItemButton
                selected={selectedMenu === item.key}
                onClick={() => setSelectedMenu(item.key)}
                sx={{
                  width: 300,
                  borderRadius: 1,
                  my: 0.5,
                  "&.Mui-selected": { bgcolor: "primary.main", color: "black" },
                  "&:hover": { bgcolor: "primary.light", color: "black" },
                }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText sx={{ color: 'black !important' }}>
                  <Typography fontWeight={"bold"} color={selectedMenu === item.key ? "black" : "gray"}>
                    {item.label}
                  </Typography>
                </ListItemText>
                {item.premiumConfig && <BadgeCheck color="blue"></BadgeCheck>}
              </ListItemButton>
            </ListItem>
          </Tooltip>
        ))}
      </List>

      {/* Main Content */}
      <Box sx={{ flexGrow: 1, p: 4 }}>
        {selectedMenu === "general" && <Configuration raffle={raffle} />}
        {selectedMenu === "chatbox" && <ChatBox raffle={raffle} />}
        {selectedMenu === "bank" && <BankAccounts raffle={raffle} />}
        {selectedMenu === "blocked" && <BlockedNumbers raffle={raffle} />}
        {selectedMenu === "bestPurchasers" && <BestPurchasers raffle={raffle} />}
        {selectedMenu === "promo" && <PromoEngine raffle={raffle} />}
        {selectedMenu === "remaining" && <Remaining raffle={raffle} />}
        {selectedMenu === "sellers" && <Sellers raffle={raffle} />}
        {selectedMenu === "customization" && <Customizations raffle={raffle} />}
      </Box>
    </Box>
  );
};

export default SettingsMenu;
